import { render, staticRenderFns } from "./IconCircleButton.vue?vue&type=template&id=47fd75bb"
import script from "./IconCircleButton.vue?vue&type=script&lang=js"
export * from "./IconCircleButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports